<template>
    <div class="m-game-data">
        <h5 class="title"></h5>

        <div class="m-player">
            <div class="title-player"></div>

            <div class="view">
                <div class="u-ctrl">
                    <div class="ui-select">
                        <div class="select-now"> {{ mpl_list[evt_now].name }}{{ mpl_list[evt_now].schedule }} <div class="u-btn trriger" @click="listActive=!listActive"></div></div>
                        <ul v-show="listActive">
                            <li v-for="(item,index) in mpl_list" :key="index"
                            @click="evt_now = index;listActive=false;get_player_rank ({ 'mid' : item.id});">{{ item.name }}{{ item.schedule }}</li>
                        </ul>                        
                    </div>
                    <div class="ui-select">
                        <div class="select-now"> {{ player_list[player_now].name }} <div class="u-btn trriger" @click="playerActive=!playerActive"></div></div>
                        <ul v-show="playerActive">
                            <li v-for="(item,index) in player_list" :key="index"
                            @click="player_now = index;playerActive=false;get_player_rank ({ 'pos' : item.id });">{{ item.name }}</li>
                        </ul>                        
                    </div>
                </div>

                <div class="data-view">
                    <div class="data-btn btn-hd">
                        <div class="u-btn" :class="{'act' : player_act == index}" v-for="(item,index) in player_config" :key="index"
                        @click="player_act = index;get_player_rank ({ 'sort' : item.id });">{{ item.name }}</div>
                    </div>

                    <div class="dataTable">
                        <table>
                            <thead>
                                <tr>
                                    <th v-for="(item,index) in player_table_head" :key="'h-' + index" :style="{'width' : item.width}"
                                    :class="{'act' : index == player_act+4}">{{ item.name }}</th>
                                </tr>
                            </thead>
                        </table>

                        <div class="data">
                            <vuescroll :ops="ops">
                            <table>
                                <tbody>
                                    <tr v-for="(item,index) in player_rank" :key="item.id">
                                        <th style="width : 80px;">
                                            <em v-if="index < 3" class="icon" :class="'icon-' + (index + 1)"></em>
                                            <span v-else>{{ (index + 1) }}</span>                                            
                                        </th>
                                        <th style="width : 172px;">{{ item.teamName }} - {{ item.player }}</th>
                                        <th style="width : 80px;">
                                            <span v-if="item.position == 0">替补位</span>
                                            <span v-if="item.position == 1">1号位</span>
                                            <span v-if="item.position == 2">2号位</span>
                                            <span v-if="item.position == 3">3号位</span>
                                            <span v-if="item.position == 4">4号位</span>
                                            <span v-if="item.position == 5">5号位</span>                                          
                                        </th>
                                        <th style="width : 80px;">{{ item.allRace }}</th>
                                        <th style="width : 80px;" :class="{'act' : player_act == 0}">{{ item.kda }}</th>
                                        <th style="width : 170px;" :class="{'act' : player_act == 1}">{{ item.k }}（{{ item.avgK }}）</th>
                                        <th style="width : 170px;" :class="{'act' : player_act == 2}">{{ item.a }}（{{ item.avgA }}）</th>
                                        <th style="width : 170px;" :class="{'act' : player_act == 3}">{{ item.d }}（{{ item.avgD }}）</th>
                                        <th style="width : 106px;" :class="{'act' : player_act == 4}">{{ item.money }}</th>
                                        <th style="width : 106px;" :class="{'act' : player_act == 5}">{{ item.avgWar }}%</th>
                                        <th :class="{'act' : player_act == 6}">{{ item.mvp }}</th>
                                    </tr>                                    
                                </tbody>
                            </table>
                            </vuescroll>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="m-hero">
            <div class="title-hero"></div>

            <div class="view">
                <div class="u-ctrl">
                    <div class="ui-select">
                        <div class="select-now"> {{ mpl_list_hero[evt_now_hero].name }}{{ mpl_list_hero[evt_now_hero].schedule }} <div class="u-btn trriger" @click="heroActive=!heroActive"></div></div>
                        <ul v-show="heroActive">
                            <li v-for="(item,index) in mpl_list_hero" :key="index"
                            @click="evt_now_hero = index;heroActive=false;get_heros_rank ({ 'mid' : item.id});">{{ item.name }}{{ item.schedule }}</li>
                        </ul>                        
                    </div>

                    <div class="hero-btn btn-hd">
                        <div class="u-btn" :class="{'act' : hero_act == index}" v-for="(item,index) in hero_config" :key="index"
                        @click="hero_act = index;get_heros_rank ({ 'sort' : item.id })">{{ item.name }}</div>
                    </div>                    
                </div>

                <div class="hero-data">
                    <div class="hero-list" v-if="ready">
                        <div class="hero-item" v-for="(item,index) in hero_rank" :key="index">
                            <!-- <p class="data-percent" v-if="sort_hero == 1">{{ item.avgUse }}%</p>
                            <p class="data-percent" v-if="sort_hero == 2">{{ item.avgBan }}%</p>
                            <p class="data-percent" v-if="sort_hero == 3">{{ item.avgWin }}%</p> -->

                            <div class="data-percent" v-if="sort_hero == 1"><countTo :startVal='0' :endVal='item.avgUse' :duration='1000'></countTo>%</div>
                            <div class="data-percent" v-if="sort_hero == 2"><countTo :startVal='0' :endVal='item.avgBan' :duration='1000'></countTo>%</div>
                            <div class="data-percent" v-if="sort_hero == 3"><countTo :startVal='0' :endVal='item.avgWin' :duration='1000'></countTo>%</div>

                            <div class="bar">
                                <div class="bar-detail" v-if="sort_hero == 1" :style="{ height : item.avgUse + '%' }"></div>
                                <div class="bar-detail" v-if="sort_hero == 2" :style="{ height : item.avgBan + '%' }"></div>
                                <div class="bar-detail" v-if="sort_hero == 3" :style="{ height : item.avgWin + '%' }"></div>
                            </div>

                            <p class="cnt"><countTo :startVal='0' :endVal='item.count' :duration='1000'></countTo>次</p>

                            <div class="avatar"><img :src="item.logo" :alt="item.heroName"></div>

                            <p class="hero-name">{{ item.heroName }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vuescroll from 'vuescroll';
import countTo from 'vue-count-to';

export default {
    components: {
        vuescroll,
        countTo,
    },       
    data (){
        return {
            evt_list : [
                { name : '2022 MSPL 夏季常规赛' , id : 1,},
                { name : '2022 MSPL 夏季常规赛' , id : 2,},
                { name : '2022 MSPL 夏季常规赛' , id : 3,},
                { name : '2022 MSPL 夏季常规赛' , id : 4,},
                { name : '2022 MSPL 夏季常规赛' , id : 5,},
            ],
            evt_now : 0,
            evt_now_hero : 0,
            listActive : false,
            player_list : [
                { name : '全部选手' , id : -1,},
                { name : '1号位' , id : 1,},
                { name : '2号位' , id : 2,},
                { name : '3号位' , id : 3,},
                { name : '4号位' , id : 4,},
                { name : '5号位' , id : 5,},
                { name : '替补位' , id : 0,},
            ],
            player_now : 0,
            playerActive : false,
            player_config : [
                { name : 'KDA' , id : 1,},
                { name : '击杀' , id : 2,},
                { name : '助攻' , id : 3,},
                { name : '死亡' , id : 4,},
                { name : '均分经济' , id : 5,},
                { name : '场均参团率' , id : 6,},
                { name : 'MVP' , id : 7,},
            ],
            player_act : 0,
            player_table_head : [
               { name : '排名' , width : '80px'},
               { name : '选手' , width : '172px'},
               { name : '位置' , width : '80px'},
               { name : '场数' , width : '80px'},
               { name : 'KDA' , width : '80px'},
               { name : '总击杀（场均）' , width : '170px'},
               { name : '总助攻（场均）' , width : '170px'},
               { name : '总死亡（场均）' , width : '170px'},
               { name : '均分经济' , width : '106px'},
               { name : '场均参团率' , width : '106px'},
               { name : 'MVP' , width : ''},
            ],
            ops: {
                rail: {
                    opacity: 1,
                    background : '#000',
                    size: '12px',
                },
                bar: {
                    background: '#2b4d69',
                    keepShow : true,
                    size: '12px',
                }
            },
            hero_config : [
                { name : '出场率' , id : 1,},
                { name : '禁用率' , id : 2,},
                { name : '获胜率' , id : 3,},
            ],
            heroActive : false,
            hero_act : 0,
            player_rank : [],
            hero_rank : [],
            ps : -1,
            sort_player : 1,
            sort_hero : 1,
            ready : false,
            mid : 1,
            mid_hero : 1,                  
        }
    },
    created (){
        this.mid = this.mpl_list.filter(function(e){
            return e.isDefault == true
        })[0].id;

        this.mid_hero = this.mpl_list.filter(function(e){
            return e.isDefault == true
        })[0].id;

    },
    props :{
        'active' : {
            default : false,
        },
        mpl_list : {
            default: () => [],
        },
        mpl_list_hero : {
            default: () => [],
        }       
    },    
    watch : {
        active (val){
            if(val && !this.ready){
                this.get_player_rank ();
                this.get_heros_rank ();         
            }
        },
    },        
    methods : {
        get_player_rank (config){

            //console.log(this.sort);
            config = config || {};
            this.sort_player = config.sort || this.sort_player;
            this.ps = config.pos > -2 ? config.pos : this.ps;
            this.mid = config.mid || this.mid;

            //console.log(this.sort);

            this.$axios.get(this.$ajax_url_map.player_rank,{
                params : {
                    mid : this.mid,
                    ps : this.ps,
                    sort : this.sort_player,
                }
            })
            .then(
                res => {
                    this.player_rank = res
                },
            )            
        },
        get_heros_rank (config){
            config = config || {};
            
            this.sort_hero = config.sort || this.sort_hero;
            this.mid_hero = config.mid || this.mid_hero;

            this.$axios.get(this.$ajax_url_map.hero_rank,{
                params : {
                    mid : this.mid_hero,
                    sort : this.sort_hero,
                    size : 9,
                }
            })
            .then(
                res => {
                    this.hero_rank = res
                    this.ready = true
                },
            )            
        },        
    },
}
</script>

<style scoped>

    .m-game-data{
        margin-top: 120px;
    }

    .m-player,.m-game-data{
        position: relative;
    }

    .title{
        width: 238px;
        height: 57px;
        margin-bottom: 40px;
        background-image: url(~@/assets/images/gameData/title.png);          
    }

    .title-player{
        width: 759px;
        height: 28px;
        margin: 0 auto 35px;
        background-image: url(~@/assets/images/gameData/title-player.png);          
    }

    .title-hero{
        width: 759px;
        height: 28px;
        margin: 0 auto 65px;
        background-image: url(~@/assets/images/gameData/title-hero.png);          
    }

    .u-ctrl{
        display: flex;
    }
    
    /* select */
    .ui-select{
        position: relative;
        width: 282px;
        margin-right: 15px;
        font-size: 20px;
        color: #e6d098;        
    }

    .select-now{
        position: relative;
        width: 282px;
        height: 52px;
        line-height: 50px;
        padding-left: 15px;
        box-sizing: border-box;
        border: 1px solid #d4c292;
        border-radius: 25px;
        background-color: #0e2037;
        z-index: 3;
    }

    .trriger{
        position: absolute;
        top: 50%;
        right: 20px;
        width: 19px;
        height: 16px;
        transform: translateY(-50%);
        background-image: url(~@/assets/images/score/icon-select.png);
    }

    .ui-select ul{
        position: absolute;
        left: 50%;
        top: 22px;
        width: 280px;
        padding-top: 47px;
        background-color: #0e2037;
        border: 1px solid #d4c292;
        transform: translateX(-50%);
        z-index: 2;
    }

    .ui-select li{
        padding-left: 15px;
        margin-bottom: 20px;
        cursor: pointer;
    }

    .ui-select li:hover{
        color: #ffd247;
    }
    
    .data-btn{       
        display: flex;
        position: absolute;
        right: 0;
        top: 70px;
    }

    .hero-btn{       
        display: flex;
    }    

    .btn-hd .u-btn{
        position: relative;
        padding: 0 15px 8px;
        font-size: 20px;
        font-weight: 700;
        color: #6b8fb3;
        border-bottom: 3px solid #39546f;
    }

    .btn-hd .u-btn.act{
        color: #ffd247;
        border-bottom: 4px solid #ffd247;
    }

    .btn-hd .u-btn.act::after{
        content: '';
        display: block;
        position: absolute;
        left: 50%;
        bottom: -16px;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 16px solid transparent;
        border-right: 16px solid transparent;
        border-top: 16px solid #ffd247;        
    }    

    .m-player .dataTable{
        width: 1398px;
        height: 600px;
        padding-top: 1px;
        margin: 20px auto 110px;
        background-image: url(~@/assets/images/gameData/bg-player.png);
    }

    .m-player .dataTable .data{
        height: 510px;
    }

    .m-player .dataTable table{
        width: 1340px;
        margin: 0 auto;
    }

    .dataTable .icon{
        display: block;
        width: 47px;
        height: 56px;
        margin: 0 auto;
        background-repeat: no-repeat;
    }

    .dataTable .icon.icon-1{
        background-image: url(~@/assets/images/score/icon-1.png);
    }

    .dataTable .icon.icon-2{
        background-image: url(~@/assets/images/score/icon-2.png);
    }
    
    .dataTable .icon.icon-3{
        background-image: url(~@/assets/images/score/icon-3.png);
    }    

    .m-player .dataTable thead tr{
        height: 82px;
        font-size: 18px;
        color: #fff;
    }

    .m-player .dataTable thead th.act,
    .m-player .dataTable tbody th.act{
        background-color: #153b67;
        color: #ffd247;
    }

    .m-player .dataTable tbody tr{
        height: 92px;
        margin: 0 35px;
        font-size: 18px;
        color: #fff;
        border-bottom: 1px solid #0e2b4c;
    }
    
    .m-hero{
        min-height: 593px;
    }

    .m-hero .u-ctrl{
        display: flex;
        justify-content: center;
    }

    .hero-list{
        display: flex;
        justify-content: space-around;
        padding: 0 150px;
        margin-top: 40px;
        font-size: 16px;
        color: #d4c292;
        text-align: center;
    }

    .hero-list .bar{
        position: relative;
        width: 24px;
        height: 265px;
        margin: 10px auto 12px;
        border: 1px solid #d4c292;
        background-color: #0e2037;
    }

    .hero-list .bar-detail{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 24px;
        height: 80%;
        background-image: linear-gradient(#966936, #cc9e5e);
        transition: all .6s ease-in;
    }

    .hero-list .avatar{
        position: relative;
        width: 71px;
        height: 72px;
        margin: 0 auto 5px;
        background-image: url(~@/assets/images/gameData/avatar.png);
    }

    .hero-list .avatar img{
        display: block;
        position: absolute;
        left: 50%;
        top: 50%;
        width: 70px;
        height: 70px;
        transform: translate(-50%,-50%);
        border-radius: 50%;       
    }
</style>


// WEBPACK FOOTER //
// src/components/page/gameData.vue